import ReactGA from 'react-ga4'

export const initAnalytics = (analyticsCode?: string): void => {
  if (analyticsCode) {
    ReactGA.initialize(analyticsCode)
  }
}
